<template>
  <section v-if="combinedExtensions.length" class="extensions section">
    <h3 class="extensions-title">Extensions</h3>
    <div
      v-for="(extension, index) in combinedExtensions"
      :key="index"
      class="extension-container"
      :class="{ 'reverse-layout': index % 2 === 0 }"
    >
      <div class="extension-image">
        <img
          :src="
            extension.extensionImage ||
            (extension.extensionCity && extension.extensionCity.cityImage)
          "
          alt="Extension Image"
        />
      </div>
      <div class="extension-text">
        <p class="extension-title">
          {{ extension.extensionTitle }}
        </p>
        <p v-html="extension.extensionOverview" />
        <p>Included in Your Stay:</p>
        <div class="extension-details" v-html="extension.extensionDetails" />
        <p class="extension-disclosure">
          Extension availability may vary based on departure dates. Please check with our
          Reservations team for details. See our Terms & Conditions for additional considerations.
        </p>
        <a
          class="button is-subtle cta extension-cta js-scroll-link"
          href="#itinerary-section"
          data-target="itinerary-section"
        >
          See Day to Day Itinerary
          <i class="fas fa-long-arrow-alt-right" />
        </a>
        <a
          v-if="extension.extensionPricing?.[0]?.pricePerPerson"
          class="button is-subtle cta extension-cta js-scroll-link"
          href="#dates-and-prices"
          data-target="dates-and-prices"
        >
          Price: {{ extension.extensionPricing[0].pricePerPerson }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import EventBus from '../../vue-functions/event-bus';

export default {
  props: ['directions'],
  data() {
    return {
      selectedDirectionName: ''
    };
  },
  computed: {
    combinedExtensions() {
      if (this.directions?.directions?.length) {
        const directionIndex = this.selectedDirectionName
          ? this.directions.directions.findIndex((dir) => dir.name === this.selectedDirectionName)
          : 0;

        const direction =
          directionIndex >= 0
            ? this.directions.directions[directionIndex]
            : this.directions.directions[0];

        if (direction) {
          const pre = direction.preExtensions || [];
          const post = direction.postExtensions || [];
          return [...pre, ...post];
        }
      }
      return [];
    }
  },
  created() {
    EventBus.$on('DIRECTION_CHANGED', (directionName) => {
      this.selectedDirectionName = directionName;
    });

    if (this.directions?.directions?.length) {
      this.selectedDirectionName = this.directions.directions[0].name;
    }
  }
};
</script>
